import { render, staticRenderFns } from "./x-table.vue?vue&type=template&id=453147eb"
import script from "./x-table.vue?vue&type=script&lang=ts"
export * from "./x-table.vue?vue&type=script&lang=ts"
import style0 from "./x-table.vue?vue&type=style&index=0&id=453147eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports